import {
  clearAllPersistedCacheByPrefix,
  getPersistedCache,
  setPersistedCache,
} from './persistedCache';

const CACHE_VERSION = 1;
const STORAGE_KEY_PREFIX = 'ahoy-cache-feature-flags-';
const COMPONENT = 'persisted-feature-flags';

function isFeatureFlagsShape(raw: unknown): raw is string[] {
  return Array.isArray(raw) && raw.every(x => typeof x === 'string');
}

export function getPersistedFeatureFlags(
  orgId: number | undefined
): string[] | undefined {
  if (orgId === undefined) {
    return undefined;
  }
  return getPersistedCache<string[]>(
    `${STORAGE_KEY_PREFIX}${orgId}`,
    CACHE_VERSION,
    isFeatureFlagsShape,
    COMPONENT
  );
}

export function setPersistedFeatureFlags(orgId: number, flags: string[]): void {
  setPersistedCache(
    `${STORAGE_KEY_PREFIX}${orgId}`,
    flags,
    CACHE_VERSION,
    COMPONENT
  );
}

export function clearAllPersistedFeatureFlags(): void {
  clearAllPersistedCacheByPrefix(STORAGE_KEY_PREFIX, COMPONENT);
}
